import PackageInfo from '../../../../package.json';
import {
  DatadogClient,
  RumInitConfiguration,
  LogsInitConfiguration,
} from '@workivate/tho-web-shared';

const commonDatadogConfig = {
  clientToken: process.env.DD_CLIENT_TOKEN ?? '',
  env:
    process.env.DEPLOYMENT_ENVIRONMENT === 'production'
      ? 'prod'
      : process.env.DEPLOYMENT_ENVIRONMENT, // Use 'prod' instead of 'live' for DataDog environment to make it consistent with other environments,
  service: 'usl',
  version: `${PackageInfo.version}_${process.env.DEPLOYMENT_ENVIRONMENT}`, // This version must match with the version that is referenced in web_cicd.yml
};

const dataDogRUMConfig: RumInitConfiguration = {
  applicationId: process.env.DD_APP_ID ?? '',
  ...commonDatadogConfig,
};

const dataDogLogsConfig: LogsInitConfiguration = {
  ...commonDatadogConfig,
};

export const initialiseDataDog = () => {
  DatadogClient.initDataDog(dataDogLogsConfig, dataDogRUMConfig);
};
